import React from 'react';

function PrimaryButton({ name,showLeadingIcon, showTrailingIcon }) {
    return (
        <>
            <button className='bg-black py-20 px-48 text-16 text-white border-2 border-white shadow-md cursor-pointer'>
                {showLeadingIcon && (
                    <div>
                        {showLeadingIcon}
                    </div>
                )}
                <div>
                    {name}
                </div>
                {showTrailingIcon && (
                    <div>
                        {showTrailingIcon}
                    </div>
                )}
            </button>
        </>
    )
}

export default PrimaryButton;